import React  from "react";

function DeleteWorker(props) {
    let { worker : { worker_name }, action } = props;
    return (
        <div>
            <div>
                <p style={{fontWeight:"bold"}}>{`Are you sure you want to ${action}  this worker ?`}</p>
                <label>{worker_name}</label>
            </div>
            <div className="text">
                <button className="btn"
                    onClick={() => props.toggle()}>
                    No
                </button>
                <button className="danger-button" onClick={() => props.handleDelete()}>
                    Yes
                </button>
            </div>
        </div>
    )
}
export default DeleteWorker;